import CRUDService from "./geral/CRUDService";

export default class ParametroGeralService extends CRUDService{
    constructor() {
        super("parametrogeral");
    }
}